module.exports = __webpack_public_path__ + "img/PlaceHolderPortrait.faf540a5.png";